import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';

export const RegisterModal = ({ onSwitchToLogin }) => {
  const { register, isLoading } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validazione password
    if (password.length < 6) {
      setError('La password deve essere di almeno 6 caratteri');
      return;
    }

    if (password !== confirmPassword) {
      setError('Le password non coincidono');
      return;
    }

    setIsSubmitting(true);

    const result = await register(email, password);

    setIsSubmitting(false);

    if (result.success) {
      // Registrazione riuscita - il componente parent può chiudere il modale
      // Il AuthContext gestirà automaticamente l'aggiornamento dello stato
    } else {
      setError(result.error || 'Errore durante la registrazione');
    }
  };

  return (
    <>
      <div className="text-center mb-6">
        <h1 className="text-3xl font-bold text-gray-800">WireCraft</h1>
        <p className="text-gray-600 mt-2">Crea un nuovo account</p>
      </div>

      {error && (
        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="register-email-modal" className="block text-sm font-medium text-gray-700 mb-2">
            Email
          </label>
          <input
            id="register-email-modal"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="tuo@email.com"
          />
        </div>

        <div>
          <label htmlFor="register-password-modal" className="block text-sm font-medium text-gray-700 mb-2">
            Password
          </label>
          <input
            id="register-password-modal"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="••••••••"
          />
          <p className="text-xs text-gray-500 mt-1">Minimo 6 caratteri</p>
        </div>

        <div>
          <label htmlFor="confirm-password-modal" className="block text-sm font-medium text-gray-700 mb-2">
            Conferma Password
          </label>
          <input
            id="confirm-password-modal"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="••••••••"
          />
        </div>

        <button
          type="submit"
          disabled={isSubmitting || isLoading}
          className="w-full bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSubmitting || isLoading ? 'Registrazione in corso...' : 'Registrati'}
        </button>
      </form>

      <div className="mt-4 text-center">
        <button
          onClick={onSwitchToLogin}
          className="text-blue-600 hover:text-blue-800 text-sm"
        >
          Hai già un account? Accedi
        </button>
      </div>
    </>
  );
};

